import { Component, Host, Prop, h } from '@stencil/core';

import { DEFAULT_LEGAL } from '../../../utils/utils.landing';

@Component({
  tag: 'landing-legal',
  styleUrl: 'landing-legal.css',
})
export class LandingLegal {
  @Prop() content: string = DEFAULT_LEGAL;
  @Prop() fullSize: boolean = false;
  @Prop() testId: string = '';

  render() {
    const fullSizeClass = {
      'col-span-full': true,
      'lg:col-start-2 lg:col-end-12': !this.fullSize,
    };
    return (
      <Host>
        <div class="grid grid-cols-4 lg:grid-cols-12 gap-4 lg:gap-6 landing-legal-text font-medium text-label leading-3 text-justify">
          <div data-testid={this.testId} class={fullSizeClass} innerHTML={this.content}></div>
        </div>
      </Host>
    );
  }
}
